import { feedbackTypes } from "..";
import { Typography, IconButton, Tooltip, Box, useTheme } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import MapsUgcOutlinedIcon from "@mui/icons-material/MapsUgcOutlined";
import { Fragment } from "react";

export function FeedbackTypeStep({ onFeedbackTypeChanged }) {
  const theme = useTheme();

  const getTypeIcon = (title) => {
    switch (title) {
      case "Problema":
        return <ErrorOutlineIcon sx={{ fontSize: 24, color: feedbackTypes.BUG.color }} />;
      case "Ideia":
        return <LightbulbOutlinedIcon sx={{ fontSize: 24, color: feedbackTypes.IDEA.color }} />;
      case "Outro":
        return <MapsUgcOutlinedIcon sx={{ fontSize: 24, color: feedbackTypes.OTHER.color }} />;
      default:
        return <HelpOutlineIcon sx={{ fontSize: 24 }} />;
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
        <Box>
          <Typography variant="h6" fontWeight="600" gutterBottom>
            Deixe seu feedback
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Seu comentário é importante para realizarmos melhorias na plataforma.
          </Typography>
        </Box>
        <Tooltip title="Iremos analisar seu Feedback e inserir em nossas melhorias na plataforma">
          <IconButton size="small" sx={{ color: theme.palette.text.secondary }}>
            <HelpOutlineIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {Object.entries(feedbackTypes).map(([key, value]) => (
          <Box
            key={key}
            onClick={() => onFeedbackTypeChanged(value)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              p: 2.5,
              borderRadius: 3,
              border: `2px solid ${theme.palette.divider}`,
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: value.color,
                backgroundColor: `${value.color}08`,
                transform: 'translateY(-2px)',
                boxShadow: `0 4px 12px ${value.color}20`,
              }
            }}
          >
            <Box sx={{ mr: 2 }}>
              {getTypeIcon(value.title)}
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle1" fontWeight="500">
                {value.title}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {value.title === "Problema" && "Relate um problema ou bug encontrado"}
                {value.title === "Ideia" && "Compartilhe uma ideia para melhorarmos"}
                {value.title === "Outro" && "Outro tipo de feedback ou comentário"}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}